import Backbone from 'backbone';
import $ from 'jquery';
import { Dialog } from '@bingads-webui/dialog';
import globalApps from '@bingads-webui-clientcenter/global-apps';
import MessageBlock from './message-block';

export default class View extends Backbone.View {
  /**
    @param {string} [el] - the dialog container of the page, default value is '.lightboxDiv', which is added in _ClientCenterPageLayout.
    @param {string} title - title
    @param {string} messageBlock - main content of the lightbox
    @param {object} midMessageBlock - Backbone view between messageBlock and subMessage block. Won't be placed in <p> tags. null if empty
    @param {string} subMessageBlock - null if no submessage.
    @param {string} infoAlertMessage - null if no infoAlertMessage.
    @param {object} primaryButton
      - @param {string} text - html tags are supported.
      - @param {function/string} event - event or url to redirect when clicking. Will trigger hide event for the lightbox when this parameter is null.
    @param {object} defaultButton
      - @param {string} text - html tags are supported.
      - @param {function/string} event - event or url to redirect when clicking. Will trigger hide event for the lightbox when this parameter is null.
    @param {string} imageClass - The class to apply to an element to make it show the image.
    @param {string} additionalMessageClass - class to add onto the message blocks.
    @return {object} Backbone view.
   */
  initialize({
    title,
    messageBlock,
    midMessageBlock,
    subMessageBlock,
    infoAlertMessage,
    primaryButton,
    defaultButton,
    el = '.lightboxDiv',
    imageClass,
    showCloseButton,
    additionalMessageClass,
  }) {
    this.el = el;
    this.title = title;
    this.messageBlock = messageBlock;
    this.midMessageBlock = midMessageBlock;
    this.subMessageBlock = subMessageBlock;
    this.infoAlertMessage = infoAlertMessage;
    this.primaryButton = primaryButton;
    this.defaultButton = defaultButton;
    this.imageClass = imageClass;
    this.showCloseButton = showCloseButton;
    this.additionalMessageClass = additionalMessageClass;

    if (title && messageBlock && (primaryButton || defaultButton)) {
      const buttons = [];

      if (primaryButton) {
        buttons.push({
          text: primaryButton.text,
          name: 'primaryButton',
          class: 'btn btn-primary lightboxPrimary',
        });
      }
      if (defaultButton) {
        buttons.push({
          text: defaultButton.text,
          name: 'defaultButton',
          class: 'btn btn-default lightboxDefault',
        });
      }

      this.lightboxDiv = new Dialog({
        showCloseButton: this.showCloseButton,
      });
      this.lightboxDiv.setContent(new MessageBlock({
        messageBlock: this.messageBlock,
        midMessageBlock: this.midMessageBlock,
        subMessageBlock: this.subMessageBlock,
        infoAlertMessage: this.infoAlertMessage,
        imageClass: this.imageClass,
        messageClass: this.additionalMessageClass ? ` ${this.additionalMessageClass}` : '',
      }));
      this.lightboxDiv.setState({
        title: this.title,
        buttons,
      });
      this.lightboxDiv.render();

      this.lightboxDiv.on('clickedButton', (name) => {
        if (name === 'primaryButton') {
          this.executeButtonEvent(this.primaryButton);
        } else if (name === 'defaultButton') {
          this.executeButtonEvent(this.defaultButton);
        }
      });
    }
  }

  render() {
    $(this.el).append(this.lightboxDiv.el);
    this.lightboxDiv.show();
    return this;
  }

  executeButtonEvent(button) {
    if (button.event && typeof button.event === 'string') {
      globalApps.navigate(button.event);
    } else if (button.event && typeof button.event === 'function') {
      button.event();
    }
    // In any case, hide the lightbox finally.
    this.lightboxDiv.remove();
  }
}
